import REST from '../REST';
import * as normalize from './normalize';

const compareCountry = (a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};

export const load = () => REST.get('/countries.json').then(raw => {
  const countries = raw.countries
    .filter(country => !country.restricted)
    .map(normalize.country)
    .sort(compareCountry);

  return {
    countries,
  };
});

export const loadRegion = () => REST.get('/countries.json').then(raw => {
  return raw.current_country_iso_code;
});



// WEBPACK FOOTER //
// ../src/resources/countries/index.js